import * as types from 'modules/predefinedMessages/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean} State */
const initialState = false;

const open = () => true;

const close = () => false;

export default createReducer(initialState, {
  [types.OPEN_DUPLICATE_MODAL]: open,
  [types.CLOSE_DUPLICATE_MODAL]: close,
  [types.CLONE_SUCCESS]: close,
});
